import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { NgClass } from '@angular/common';

export enum ContactTypes {
  ADDRESS = "addresses",
  EMAIL = "emails",
  ORGANISATION = "org",
  PHONE = "phones",
  URL = "urls",
  BIRTHDAY = "birthdays"
}

@Component({
    selector: 'contact-dropdown-button',
    templateUrl: './contact-dropdown-button.component.html',
    styleUrls: ['./contact-dropdown-button.component.scss'],
    imports: [MatTooltip, NgClass]
})
export class ContactDropdownButtonComponent implements OnInit, OnChanges {

  constructor() { }

  @ViewChild("dropdownMenu") dropdownMenu: ElementRef

  @Output() addContact: EventEmitter<ContactTypes> = new EventEmitter();

  @Input() contactInfo: any = {}

  readonly VALIDATION = {
    addresses: 2,
    emails: 2,
    phones: 2,
    urls: 2,
    org: 1,
    birthdays: 1,
  }

  readonly ContactTypes = ContactTypes;

  isDisable = {
    addresses: false,
    emails: false,
    phones: false,
    urls: false,
    org: false,
    birthdays: false,
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.setValidation()
  }

  public selectANewField() {
    this.dropdownMenu.nativeElement.classList.toggle('show');
  }

  public contactClick(contact: ContactTypes) {
    this.dropdownMenu.nativeElement.classList.remove('show');
    this.addContact.emit(contact)
  }

  private setValidation() {
    for (const validation in this.VALIDATION) {
      if (this.contactInfo.hasOwnProperty(validation)) {
        const control = this.contactInfo[validation];
        this.isDisable[validation] = control.length === this.VALIDATION[validation];
      }
    }
  }

}
